// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2e-0";
export var spinnerContainer = "_2e-1";